const kidsAgesViewModule = () => import(/* webpackChunkName: 'components/search/kidsAgesView' */'../../searchForm/participants/kidsAge/kidsAge');

import { infoPopinPanelParticipants }  from '../../infoPopinPanelParticipants/infoPopinPanelParticipants.js';
import { genericTooltip } from '../../genericTooltip/genericTooltip';

export const ParticipantsView = Backbone.View.extend({
  events: {
    'click .js-capacityFull-validate': 'capacityValidate',
    'click #searchEngine-cottage .form-QuantityAdder': 'displayPanelParticipants',
    'click #searchEngine-cottage .form-QuantityRemover': 'hidePanelParticipants'
  },

  initialize: function (options) {
    this.setElement(options.element);
    this.wordings = SEARCH_SCRIPTS.WORDING_SEARCH;
    this.model = options.model;
    this.mainEngineModel = this.model.get('mainSearch');
    this.temporaryModel = this.model.get('temporarySearch');
    this.isFacetteMultiParticipants = typeof isFacetteMultiParticipants !== 'undefined';
    this.firstChidrenAgesOpening = true;
    this.lastParticipantsModified = false;
    this.isFirstLoad = true;
    this.memoMaxParticipants = this.temporaryModel.get('participantsRules').maxParticipants;//ER2813 : gestion de la suppression du loader

    this.initListener();

    this.capacityRules = {};
    this.initCapacity(true);

    kidsAgesViewModule().then(({KidsAgesView}) => {
      const kidsAgeOptions = {
        viewElement: '.searchForm-capacityContainer',
        inputChildrenSelector: '#js-searchEngine-childrenNumber',
        inputChildren2Selector: '#js-searchEngine-childrenNumber_02',
        triggerPrefix: 'facette:participants',
        model: this.temporaryModel
      };

      this.KidsAgesView = new KidsAgesView(kidsAgeOptions);
    });
  },

  initListener: function () {
    this.stopListening(dispatcher, 'facette:participants:initCapacity');
    this.listenTo(dispatcher, 'facette:participants:initCapacity', this.initCapacity);

    this.stopListening(dispatcher, 'facette:participants:render');
    this.listenTo(dispatcher, 'facette:participants:render', this.render);

    this.stopListening(dispatcher, 'facette:participants:updateModel');
    this.listenTo(dispatcher, 'facette:participants:updateModel', this.updateModel);

    this.stopListening(dispatcher, 'facette:participants:handleParticipantsDisplay');
    this.listenTo(dispatcher, 'facette:participants:handleParticipantsDisplay', this.handleParticipantsDisplay);

    this.stopListening(dispatcher, 'facette:participants:updateFieldParticipants');
    this.listenTo(dispatcher, 'facette:participants:updateFieldParticipants', this.updateFieldParticipants);

    this.stopListening(dispatcher, 'facette:participants:updateCapacitySearchStored');
    this.listenTo(dispatcher, 'facette:participants:updateCapacitySearchStored', this.updateCapacitySearchStored);
  },

  /*** handling capacity (adults/children/babies) and accommodation number ***/
  initCapacity: function () {
    const participantsRules = this.mainEngineModel.get('participantsRules');

    let childrenOptions = {},
      seniorsOptions = {},
      petsOptions = {},
      adults2Options = {},
      children2Options = {},
      seniors2Options = {},
      pets2Options = {};

    //instanciate quantity selectors behaviours
    const adultsOptions = {
      element: $('#searchEngine-adults'),
      rules: {
        min: participantsRules.adults.min,
        max: participantsRules.adults.max,
        useSelectorDefaultCheck: false
      },
      addCallBack: 'facette:participants:updateModel',
      removeCallBack: 'facette:participants:updateModel',
      identifier: 'adults'
    };

    new Form.QuantitySelectorView(adultsOptions);

    if (this.isFacetteMultiParticipants) {
      adults2Options = {
        element: $('#searchEngine-adults_02'),
        rules: {
          min: participantsRules.adults.min,
          max: participantsRules.adults.max,
          useSelectorDefaultCheck: false
        },
        addCallBack: 'facette:participants:updateModel',
        removeCallBack: 'facette:participants:updateModel',
        identifier: 'adults_02'
      };
      new Form.QuantitySelectorView(adults2Options);

      seniorsOptions = {
        element: $('#searchEngine-seniors'),
        rules: {
          min: participantsRules.seniors.min,
          max: participantsRules.seniors.max,
          useSelectorDefaultCheck: false
        },
        addCallBack: 'facette:participants:updateModel',
        removeCallBack: 'facette:participants:updateModel',
        identifier: 'seniors'
      };
      new Form.QuantitySelectorView(seniorsOptions);

      seniors2Options = {
        element: $('#searchEngine-seniors_02'),
        rules: {
          min: participantsRules.seniors.min,
          max: participantsRules.seniors.max,
          useSelectorDefaultCheck: false
        },
        addCallBack: 'facette:participants:updateModel',
        removeCallBack: 'facette:participants:updateModel',
        identifier: 'seniors_02'
      };
      new Form.QuantitySelectorView(seniors2Options);

      childrenOptions = {
        element: $('#searchEngine-children'),
        rules: {
          min: participantsRules.children.min + participantsRules.babies.min,
          max: participantsRules.children.max + participantsRules.babies.max,
          useSelectorDefaultCheck: false
        },
        addCallBack: 'kidsAges:render',
        removeCallBack: 'kidsAges:render',
        identifier: 'kids'
      };
      new Form.QuantitySelectorView(childrenOptions);

      children2Options = {
        element: $('#searchEngine-children_02'),
        rules: {
          min: participantsRules.children.min + participantsRules.babies.min,
          max: participantsRules.children.max + participantsRules.babies.max,
          useSelectorDefaultCheck: false
        },
        addCallBack: 'kidsAges:render',
        removeCallBack: 'kidsAges:render',
        identifier: 'kids_02'
      };
      new Form.QuantitySelectorView(children2Options);

      petsOptions = {
        element: $('#searchEngine-pets'),
        rules: {
          min: typeof participantsRules.pets !== 'undefined' ? participantsRules.pets.min : 0,
          max: typeof participantsRules.pets !== 'undefined' ? participantsRules.pets.max : 0,
          useSelectorDefaultCheck: false
        },
        addCallBack: 'facette:participants:updateModel',
        removeCallBack: 'facette:participants:updateModel',
        identifier: 'pets'
      };
      new Form.QuantitySelectorView(petsOptions);

      pets2Options = {
        element: $('#searchEngine-pets_02'),
        rules: {
          min: typeof participantsRules.pets !== 'undefined' ? participantsRules.pets.min : 0,
          max: typeof participantsRules.pets !== 'undefined' ? participantsRules.pets.max : 0,
          useSelectorDefaultCheck: false
        },
        addCallBack: 'facette:participants:updateModel',
        removeCallBack: 'facette:participants:updateModel',
        identifier: 'pets_02'
      };
      new Form.QuantitySelectorView(pets2Options);
    }

    this.participantsParams = {//ne sert sans doute à rien, mieux vaut se baser sur al mise à jour des participantsRules
      adults: adultsOptions,
      seniors: seniorsOptions,
      children: childrenOptions,
      pets: petsOptions,
      adults2: adults2Options,
      seniors2: seniors2Options,
      children2: children2Options,
      pets2: pets2Options
    };

    if (this.isFacetteMultiParticipants) {
      //instantiate childrenMaxError
      $('#searchEngine-children .form-QuantitySelector').off('click.childrenMaxError').on('click.childrenMaxError', () => {
        const nbChildren = parseInt($('#js-searchEngine-childrenNumber').val()),
          nbAdults = this.temporaryModel.get('multiparticipants')[0].adults,
          nbSeniors = this.temporaryModel.get('multiparticipants')[0].seniors,
          participantsRules = this.temporaryModel.get('participantsRules'),
          nbRemainingMaxParticipants = participantsRules.maxParticipants - nbAdults - nbSeniors,
          maxMinors = participantsRules.children.max + participantsRules.babies.max,
          effectiveMaxMinors = nbRemainingMaxParticipants > maxMinors ? maxMinors : nbRemainingMaxParticipants;

        if (nbChildren >= effectiveMaxMinors) {
          $('#searchEngine-children .js-formQuantity-errorMessage').removeClass('u-Hidden').addClass('display-alertError');
        } else {
          $('#searchEngine-children .js-formQuantity-errorMessage').addClass('u-Hidden').removeClass('display-alertError');
        }
      });
    }
  },

  capacityValidate: function (event) {
    event.preventDefault();

    //close
    this.closeLists();
  },

  //la mise à jour du model entraine les rendus liés
  updateModel: function (identifier, quantity) {
    //pre-controle de la quantité envoyée
    const participantsRules = this.temporaryModel.get('participantsRules'),
      maxGrownUp = participantsRules.adults.max,
      maxMinors = participantsRules.children.max + participantsRules.babies.max,
      maxPets = participantsRules.pets.max,
      nbSeniors = this.temporaryModel.get('multiparticipants')[0].seniors,
      nbSeniors2 = this.temporaryModel.get('multiparticipants')[1].seniors,
      nbAdults = this.temporaryModel.get('multiparticipants')[0].adults,
      nbAdults2 = this.temporaryModel.get('multiparticipants')[1].adults;

    let validQuantity = quantity;
    switch (identifier) {
      case 'adults':
        if ((quantity + nbSeniors) > maxGrownUp) {
          validQuantity = maxGrownUp - nbSeniors;
          $('#js-searchEngine-adultNumber').val(validQuantity);
        }
        break;
      case 'adults_02':
        if ((quantity + nbSeniors2) > maxGrownUp) {
          validQuantity = maxGrownUp - nbSeniors2;
          $('#js-searchEngine-adultNumber_02').val(validQuantity);
        }
        break;
      case 'seniors':
        if ((quantity + nbAdults) > maxGrownUp) {
          validQuantity = maxGrownUp - nbAdults;
          $('#js-searchEngine-seniorNumber').val(validQuantity);
        }
        break;
      case 'seniors_02':
        if ((quantity + nbAdults2) > maxGrownUp) {
          validQuantity = maxGrownUp - nbAdults2;
          $('#js-searchEngine-seniorNumber_02').val(validQuantity);
        }
        break;
      case 'children':
        if (quantity > maxMinors) {
          validQuantity = maxMinors;
          $('#js-searchEngine-childrenNumber').val(validQuantity);
        }
        break;
      case 'children2':
        if (quantity > maxMinors) {
          validQuantity = maxMinors;
          $('#js-searchEngine-childrenNumber_02').val(validQuantity);
        }
        break;
      case 'pets':
        if (quantity > maxPets) {
          validQuantity = maxPets;
          $('#js-searchEngine-petsNumber').val(validQuantity);
        }
        break;
      case 'pets2':
        if (quantity > maxPets) {
          validQuantity = maxPets;
          $('#js-searchEngine-petsNumber_02').val(validQuantity);
        }
        break;
    }

    //enregistrement de la modification (et déclenchement appel ajax api via le model watch)
    this.lastParticipantsModified = identifier;

    this.updateFieldParticipants();
  },

  updateCapacitySearchStored: function () {
    if (this.isFacetteMultiParticipants) {
      const nbAdults = this.temporaryModel.get('multiparticipants')[0].adults !== null ? this.temporaryModel.get('multiparticipants')[0].adults : 2,
        nbSeniors = this.temporaryModel.get('multiparticipants')[0].seniors !== null ? this.temporaryModel.get('multiparticipants')[0].seniors : 0,
        nbPets = this.temporaryModel.get('multiparticipants')[0].pets !== null ? this.temporaryModel.get('multiparticipants')[0].pets : 0,
        ages = this.temporaryModel.get('multiparticipants')[0].ages !== null ? this.temporaryModel.get('multiparticipants')[0].ages : [],
        nbAdults2 = this.temporaryModel.get('multiparticipants')[1].adults !== null ? this.temporaryModel.get('multiparticipants')[1].adults : 0,
        nbSeniors2 = this.temporaryModel.get('multiparticipants')[1].seniors !== null ? this.temporaryModel.get('multiparticipants')[1].seniors : 0,
        nbPets2 = this.temporaryModel.get('multiparticipants')[1].pets !== null ? this.temporaryModel.get('multiparticipants')[1].pets : 0,
        ages2 = this.temporaryModel.get('multiparticipants')[1].ages !== null ? this.temporaryModel.get('multiparticipants')[1].ages : [];

      let storedAges = [],
        kidsAges = [],
        storedAges2 = [],
        kidsAges2 = [];

      $.each(ages, (_index, age) => {
        storedAges.push({'key': age, 'value': age});
        kidsAges.push(age);
      });

      $.each(ages2, (_index, age) => {
        storedAges2.push({'key': age, 'value': age});
        kidsAges2.push(age);
      });


      //mise à jour du storeSearch temporaire
      let oParticipants = null;

      const participantsRules = this.temporaryModel.get('participantsRules');
      const isDefaultValues = nbSeniors === participantsRules.seniors.default && nbAdults === participantsRules.adults.default && nbPets === participantsRules.pets.default && kidsAges === participantsRules.ages.default;

      if (!isDefaultValues) {
        oParticipants = [{
          senior: {
            key: nbSeniors,
            value: nbSeniors
          },
          adult: {
            key: nbAdults,
            value: nbAdults
          },
          pet: {
            key: nbPets,
            value: nbPets
          },
          ages: storedAges
        }, {
          senior: {
            key: nbSeniors2,
            value: nbSeniors2
          },
          adult: {
            key: nbAdults2,
            value: nbAdults2
          },
          pet: {
            key: nbPets2,
            value: nbPets2
          },
          ages: storedAges2
        }];
      }

      dispatcher.trigger('search:updateMainSearchStore', 'multiparticipants', oParticipants);
    } else {
      const capacity = this.temporaryModel.get('capacity'),
        arrCapacities = [{'key': capacity, 'value': capacity}];

      dispatcher.trigger('search:updateMainSearchStore', 'capacities', arrCapacities);
    }
  },

  //gestion des messages d'alerte sur les selecteurs de quantité
  checkMaxParticipants: function () {
    const participantsRules = this.temporaryModel.get('participantsRules'),
      maxGrownUp = participantsRules.adults.max,
      nbGrownUp = this.temporaryModel.get('multiparticipants')[0].adults + this.temporaryModel.get('multiparticipants')[0].seniors,
      maxPets = participantsRules.pets.max,
      nbPets = this.temporaryModel.get('multiparticipants')[0].pets;

    $('.form-quantityErrorMessage').addClass('u-Hidden').removeClass('display-alertError');

    if (nbGrownUp >= maxGrownUp) {
      if (this.lastParticipantsModified === 'seniors') {
        $('#searchEngine-seniors .form-quantityErrorMessage').removeClass('u-Hidden').addClass('display-alertError');
      }
      if (this.lastParticipantsModified === 'adults') {
        $('#searchEngine-adults .form-quantityErrorMessage').removeClass('u-Hidden').addClass('display-alertError');
      }
    }

    if (nbPets >= maxPets && this.lastParticipantsModified === 'pets') {
      $('#searchEngine-pets .form-quantityErrorMessage').removeClass('u-Hidden').addClass('display-alertError');
    }
  },

  //handle disable status of participants quantity
  handleParticipantsDisplay: function () {
    const participantsRules = this.mainEngineModel.get('participantsRules'),
      nbAdults = this.temporaryModel.get('multiparticipants')[0].adults,
      nbSeniors = this.temporaryModel.get('multiparticipants')[0].seniors,
      nbPets = this.temporaryModel.get('multiparticipants')[0].pets,
      nbAdults2 = this.temporaryModel.get('multiparticipants')[1].adults,
      nbSeniors2 = this.temporaryModel.get('multiparticipants')[1].seniors,
      nbPets2 = this.temporaryModel.get('multiparticipants')[1].pets,
      adultsParams = this.participantsParams.adults,
      adults2Params = this.participantsParams.adults2,
      seniorsParams = this.participantsParams.seniors,
      seniors2Params = this.participantsParams.seniors2,
      childrenParams = this.participantsParams.children,
      children2Params = this.participantsParams.children2,
      petsParams = this.participantsParams.pets,
      pets2Params = this.participantsParams.pets2,

      $seniorsElement = $(seniorsParams.element),
      $seniorsInput = $seniorsElement.find('.js-formQuantityValue'),
      $seniorsRemover = $seniorsElement.find('.form-QuantityRemover'),
      $seniorsAdder = $seniorsElement.find('.form-QuantityAdder'),
      $seniors2Element = $(seniors2Params.element),
      $seniors2Input = $seniors2Element.find('.js-formQuantityValue'),
      $seniors2Remover = $seniors2Element.find('.form-QuantityRemover'),
      $seniors2Adder = $seniors2Element.find('.form-QuantityAdder'),

      $adultElement = $(adultsParams.element),
      $adultsInput = $adultElement.find('.js-formQuantityValue'),
      $adultsRemover = $adultElement.find('.form-QuantityRemover'),
      $adultsAdder = $adultElement.find('.form-QuantityAdder'),
      $adult2Element = $(adults2Params.element),
      $adults2Input = $adult2Element.find('.js-formQuantityValue'),
      $adults2Remover = $adult2Element.find('.form-QuantityRemover'),
      $adults2Adder = $adult2Element.find('.form-QuantityAdder'),
      $childElement = $(childrenParams.element),
      $childrenInput = $childElement.find('.js-formQuantityValue'),
      $childrenRemover = $childElement.find('.form-QuantityRemover'),
      $childrenAdder = $childElement.find('.form-QuantityAdder'),
      $child2Element = $(children2Params.element),
      $children2Input = $child2Element.find('.js-formQuantityValue'),
      $children2Remover = $child2Element.find('.form-QuantityRemover'),
      $children2Adder = $child2Element.find('.form-QuantityAdder'),
      $petElement = $(petsParams.element),
      $petsInput = $petElement.find('.js-formQuantityValue'),
      $petsRemover = $petElement.find('.form-QuantityRemover'),
      $petsAdder = $petElement.find('.form-QuantityAdder'),
      $pet2Element = $(pets2Params.element),
      $pets2Input = $pet2Element.find('.js-formQuantityValue'),
      $pets2Remover = $pet2Element.find('.form-QuantityRemover'),
      $pets2Adder = $pet2Element.find('.form-QuantityAdder'),

      nbRemainingMaxAdults = participantsRules.adults.max - nbAdults - nbSeniors,
      nbRemainingMaxAdults2 = participantsRules.adults.max - nbAdults2 - nbSeniors2,
      maxMinors = participantsRules.children.max + participantsRules.babies.max,
      nbGrownUp = nbAdults + nbSeniors,
      nbGrownUp2 = nbAdults2 + nbSeniors2,
      effectiveMaxMinors = this.isFacetteMultiParticipants ? nbRemainingMaxAdults > maxMinors ? maxMinors : nbRemainingMaxAdults + participantsRules.babies.max : 0,
      effectiveMaxMinors2 = this.isFacetteMultiParticipants ? nbRemainingMaxAdults2 > maxMinors ? maxMinors : nbRemainingMaxAdults2 + participantsRules.babies.max : 0,
      nbChildren = parseInt($($childrenInput).val()),
      nbChildren2 = parseInt($($children2Input).val()),
      nbBabies = $('#js-searchEngine .kidsAgesContainer .js-selectKidAge-container.isBaby').length,
      nbBabies2 = $('.kidsAgesContainerMulticottage .js-selectKidAgeMulticottage-container.isBaby').length,
      effectiveMaxGrownUp = participantsRules.adults.max - nbChildren + nbBabies, //le nombre maximum d'adulte varie en fonction du nombre de bébé effectivement sélectionné
      effectiveMaxGrownUp2 = participantsRules.adults.max - nbChildren2 + nbBabies2; //le nombre maximum d'adulte varie en fonction du nombre de bébé effectivement sélectionné
    //handle button and values display
    if (this.isFacetteMultiParticipants) {
      //handling adults and seniors
      if (nbAdults === 0) {
        $adultsInput.addClass('u-disabled');
        $adultsRemover.addClass('u-disabled');
      }

      $seniorsInput.toggleClass('u-disabled', nbSeniors === 0);
      $seniorsRemover.toggleClass('u-disabled', nbSeniors === 0);

      if (nbGrownUp === 1 || nbGrownUp === adultsParams.rules.min) {
        $adultsRemover.addClass('u-disabled');
        $seniorsRemover.addClass('u-disabled');
        $seniorsAdder.removeClass('u-disabled');
        $adultsAdder.removeClass('u-disabled');
      } else if (nbGrownUp >= effectiveMaxGrownUp) {
        $adultsRemover.removeClass('u-disabled');
        $seniorsRemover.removeClass('u-disabled');
        $adultsAdder.addClass('u-disabled');
        $seniorsAdder.addClass('u-disabled');
        $adultsInput.removeClass('u-disabled');
        $seniorsInput.removeClass('u-disabled');
      } else {
        $adultsRemover.removeClass('u-disabled');
        $seniorsRemover.removeClass('u-disabled');
        $seniorsAdder.removeClass('u-disabled');
        $adultsAdder.removeClass('u-disabled');
        $adultsInput.removeClass('u-disabled');
        $seniorsInput.removeClass('u-disabled');
      }

      // handling adults and seniors multicottage
      if (nbGrownUp2 === 1 || nbGrownUp2 === adultsParams.rules.min) {
        $adults2Remover.addClass('u-disabled');
        $seniors2Remover.addClass('u-disabled');
        $seniors2Adder.removeClass('u-disabled');
        $adults2Adder.removeClass('u-disabled');
      } else if (nbGrownUp2 >= effectiveMaxGrownUp2) {
        $adults2Remover.removeClass('u-disabled');
        $seniors2Remover.removeClass('u-disabled');
        $adults2Adder.addClass('u-disabled');
        $seniors2Adder.addClass('u-disabled');
        $adults2Input.removeClass('u-disabled');
        $seniors2Input.removeClass('u-disabled');
      } else {
        $adults2Remover.removeClass('u-disabled');
        $seniors2Remover.removeClass('u-disabled');
        $seniors2Adder.removeClass('u-disabled');
        $adults2Adder.removeClass('u-disabled');
        $adults2Input.removeClass('u-disabled');
        $seniors2Input.removeClass('u-disabled');
      }

      if (nbAdults2 === 0) {
        $adults2Input.removeClass('u-disabled');
        $adults2Remover.addClass('u-disabled');
      }

      if (nbSeniors2 === 0) {
        $seniors2Input.addClass('u-disabled');
        $seniors2Remover.addClass('u-disabled');
      }

      // minors
      if (nbChildren === 0 || nbChildren === childrenParams.rules.min) {
        if (nbChildren === 0) {
          $childrenInput.addClass('u-disabled');
        } else {
          $childrenInput.removeClass('u-disabled');
        }
        $childrenRemover.addClass('u-disabled');
        $childrenAdder.removeClass('u-disabled');
      } else if (nbChildren >= effectiveMaxMinors) {
        $childrenInput.removeClass('u-disabled');
        $childrenRemover.removeClass('u-disabled');
        $childrenAdder.addClass('u-disabled');
      } else {
        $childrenInput.removeClass('u-disabled');
        $childrenRemover.removeClass('u-disabled');
        $childrenAdder.removeClass('u-disabled');
      }

      // minors multicottage
      if (nbChildren2 === 0 || nbChildren2 === children2Params.rules.min) {
        if (nbChildren2 === 0) {
          $children2Input.addClass('u-disabled');
        } else {
          $children2Input.removeClass('u-disabled');
        }
        $children2Remover.addClass('u-disabled');
        $children2Adder.removeClass('u-disabled');
      } else if (nbChildren2 >= effectiveMaxMinors2) {
        $children2Input.removeClass('u-disabled');
        $children2Remover.removeClass('u-disabled');
        $children2Adder.addClass('u-disabled');
      } else {
        $children2Input.removeClass('u-disabled');
        $children2Remover.removeClass('u-disabled');
        $children2Adder.removeClass('u-disabled');
      }

      // pets
      if (nbPets === 0 || nbPets === petsParams.rules.min) {
        if (nbPets === 0) {
          $petsInput.addClass('u-disabled');
        } else {
          $petsInput.removeClass('u-disabled');
        }
        $petsRemover.addClass('u-disabled');
        $petsAdder.removeClass('u-disabled');
      } else if (nbPets === petsParams.rules.max) {
        $petsInput.removeClass('u-disabled');
        $petsRemover.removeClass('u-disabled');
        $petsAdder.addClass('u-disabled');
      } else {
        $petsInput.removeClass('u-disabled');
        $petsRemover.removeClass('u-disabled');
        $petsAdder.removeClass('u-disabled');
      }

      // pets multicottage
      if (nbPets2 === 0 || nbPets2 === pets2Params.rules.min) {
        if (nbPets2 === 0) {
          $pets2Input.addClass('u-disabled');
        } else {
          $pets2Input.removeClass('u-disabled');
        }
        $pets2Remover.addClass('u-disabled');
        $pets2Adder.removeClass('u-disabled');
      } else if (nbPets2 === pets2Params.rules.max) {
        $pets2Input.removeClass('u-disabled');
        $pets2Remover.removeClass('u-disabled');
        $pets2Adder.addClass('u-disabled');
      } else {
        $pets2Input.removeClass('u-disabled');
        $pets2Remover.removeClass('u-disabled');
        $pets2Adder.removeClass('u-disabled');
      }
    } else {
      // adults
      if (nbAdults === adultsParams.rules.min) {
        $adultsRemover.addClass('u-disabled');
        $adultsAdder.removeClass('u-disabled');
      } else if (nbAdults === adultsParams.rules.max) {
        $adultsRemover.removeClass('u-disabled');
        $adultsAdder.addClass('u-disabled');
      } else {
        $adultsRemover.removeClass('u-disabled');
        $adultsAdder.removeClass('u-disabled');
      }

      // adults multicottage
      if (nbAdults2 === adultsParams.rules.min) {
        $adults2Remover.addClass('u-disabled');
        $adults2Adder.removeClass('u-disabled');
      } else if (nbAdults2 === adultsParams.rules.max) {
        $adults2Remover.removeClass('u-disabled');
        $adults2Adder.addClass('u-disabled');
      } else {
        $adults2Remover.removeClass('u-disabled');
        $adults2Adder.removeClass('u-disabled');
      }
    }

    const firstCottage = typeof event !== 'undefined' ? $(event.currentTarget).parents('#searchEngine-children').length > 0 : false;
    $(firstCottage || !DEVICE.ismobile ? '#searchEngine-children' : '#searchEngine-children_02').closest('.searchForm-quantityBlockLine').find('.form-selectErrorMessage').removeClass('display-alertError').addClass('u-Hidden');

    if ($('.js-selectKidAge').length || $('.js-selectKidAgeMulticottage').length) {
      //on s'assure de l'activation du bouton "-" si un select kid age a été créé
      $('#searchEngine-children .form-QuantityRemover').removeClass('u-disabled');

      //on vérifie le status des kids ages si une modification change un max
      dispatcher.trigger('kidsAges:handleAgeSelectStatus');
    }
  },

  updateFieldParticipants: function (silent = false) {
    const nbCottage = parseInt($('#js-searchEngine-cottageNumber').val()),
      hasMulticottage = nbCottage > 1 ? true : false,
      cottageLabel = `${hasMulticottage ? this.wordings.cottage_plural : this.wordings.cottage_singular},`,
      adults = parseInt($('#js-searchEngine-adultNumber').val()),
      seniors = parseInt($('#js-searchEngine-seniorNumber').val()),
      children = parseInt($('#js-searchEngine-childrenNumber').val()),
      ages = this.temporaryModel.get('multiparticipants')[0].ages,
      pets = parseInt($('#js-searchEngine-petsNumber').val()),
      adults2 = !hasMulticottage ? 0 : parseInt($('#js-searchEngine-adultNumber_02').val()),
      seniors2 = !hasMulticottage ? 0 : parseInt($('#js-searchEngine-seniorNumber_02').val()),
      children2 = !hasMulticottage ? 0 : parseInt($('#js-searchEngine-childrenNumber_02').val()),
      ages2 = !hasMulticottage ? [] : this.temporaryModel.get('multiparticipants')[1].ages,
      pets2 = !hasMulticottage ? 0 : parseInt($('#js-searchEngine-petsNumber_02').val()),
      nbParticipants = adults + seniors + children + (hasMulticottage ? adults2 + seniors2 + children2 : 0),
      nbPets = pets + (hasMulticottage ? pets2 : 0),
      $link = $('.searchForm-capacity .js-displaySearchFormList:not(.js-searchForm-dataCloser)'),
      $targetCottage = $('.searchForm-cottageNb--number'),
      $targetCottageLabel = $('.searchForm-cottageNb--label'),
      $targetParticipants = $('.searchForm-participantNb'),
      $targetCapacity = $('.searchForm-capacityNb'),
      label = nbParticipants > 1 ? $link.data('labelplural') : $link.data('labelsing'),
      labelPets = nbPets > 1 ? this.wordings.pet_plural : this.wordings.pet_singular,
      htmlParticipants = '<span class="searchForm-participantNb--number">&nbsp;' + nbParticipants + '&nbsp;</span><span class="searchForm-participantNb--label">' + label + '</span>';

    $targetParticipants.html(htmlParticipants);
    $targetCottage.html(nbCottage);
    $targetCottageLabel.html(cottageLabel);

    if (nbPets > 0) {
      const htmlPets = `<span class="searchForm-petsNb"><span class="u-Visible-mobile searchForm-petsNb--addition"> + </span><span class="u-Hidden-mobile icon icon-dog searchForm-petsNb--icon"></span>${nbPets}<span class="searchForm-petsNb--label">${labelPets}</span></span>`;
      $('.searchForm-petsNb').remove();
      if (!DEVICE.isMobile) {
        $(htmlPets).insertAfter($targetParticipants);
      } else {
        $(htmlPets).insertAfter($targetCapacity);
      }

    } else {
      $('.searchForm-petsNb').remove();
    }

    // Si 2 hébergements, one reset les filtes sélectionnés et les counts
    if (nbCottage === 2) {
      dispatcher.trigger('filterModel:reset', true);
      $('.searchbar__filters__item').removeClass('active');
      $('.js-filterOpener').removeClass('has-counter');
      $('.filter-button__counter').empty();
      $('.hiddenMC').each(function () {
        $(this).addClass('u-Invisible');
      });
    } else {
      $('.hiddenMC').each(function () {
        $(this).removeClass('u-Invisible');
      });
    }
    // on en profite pour mettre à jour le nombre total de participants dans le modèle
    this.temporaryModel.set({
      'totalParticipants': nbParticipants,
      'multiparticipants': [{
        adults: adults,
        seniors: seniors,
        ages: ages,
        pets: pets
      }, {
        adults: adults2,
        seniors: seniors2,
        ages: ages2,
        pets: pets2
      }],
      'accommodationNb': nbCottage
    }, {silent});

    //en absence de loader global sur la facette, on lance la gestion d'activation/désactivation des boutons +/- et des messages d'alertes
    this.handleParticipantsDisplay();//a supprimer si on remet le loader
    this.checkMaxParticipants();//a supprimer si on remet le loader

    this.updateCapacitySearchStored();
  },

  displayPanelParticipants: function () {
    const $cottagerAdder = $('#searchEngine-cottage .form-QuantityAdder-container');

    if (this.temporaryModel.get('isFlexPeriod') || this.temporaryModel.get('duration')) {
      if (!$cottagerAdder.find('.genericTooltip').length) {
        genericTooltip.create($cottagerAdder, {
          id: 'flexPeriodDisableMC',
          text: SEARCH_SCRIPTS.WORDING_SEARCH.flexPeriodDisableMC,
          open: true
        });
      } else {
        genericTooltip.open('flexPeriodDisableMC');
      }

      $cottagerAdder.find('.js-quantitySelect').addClass('u-disabled');
    } else {
      $cottagerAdder.find('.js-quantitySelect').addClass('u-disabled');
      $('#mainCalendar').removeClass('isFlex');
      $('.js-dateFlexType.dateFlex').addClass('disable');
      $('.searchForm-quantityBlockCottage:nth-child(2) .form-QuantityContainer, .searchForm-quantityBlock--separator').removeClass('hidden');
      $('.searchForm-panel').addClass('searchForm-panel--bigger');
      $('.searchForm-quantityBlock--Cottage').addClass('opened');

      if ($('.searchForm-quantityBlock--Cottage .form-QuantityAdder').hasClass('u-disabled') && parseInt($('#js-searchEngine-cottageNumber').val()) === 2) {
        let urlContact = $('.qb--content .mainLink').data().urlcontact;
        let htmlInfoMoreCottage = infoPopinPanelParticipants({
          textBegin: SEARCH_SCRIPTS.WORDING_SEARCH.facette_participant_moreMoreMoreAccomodationBegin,
          textEnd: SEARCH_SCRIPTS.WORDING_SEARCH.facette_participant_moreMoreAccomodationEnd,
          jsClass: ' js-contactezNous',
          urlContact: urlContact,
          hasToDisplayPhoneNumber: true
        });

        if (DEVICE.isMobile) {
          $('body').append(`<div class="searchForm-quantityBlock--information">${htmlInfoMoreCottage}</div>`).addClass('popinOpened');
        } else {
          $('.searchForm-quantityBlock--information').html(htmlInfoMoreCottage).removeClass('hidden');
        }

        /* TRACKING */
        Tracking.dataLayerPush({
          clickCode: '',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'Multicottage-Popin accommodation',
          gaLabel: 'Max reached accommodation',
          event: 'clickEvent'
        });
      } else {
        $('.searchForm-quantityBlock--information').addClass('hidden');
        if (DEVICE.isMobile) {
          $('body').removeClass('popinOpened');
          $('.searchForm-quantityBlock--information').html();
        }
      }

      $('.cp-overlay, .js-closeMessage').off('click').on('click', () => {
        $('.searchForm-quantityBlock--information').addClass('hidden');
        if (DEVICE.isMobile) {
          $('body').removeClass('popinOpened');
          $('.searchForm-quantityBlock--information').html();
        }
      });

      $('.js-contactezNous').off('click').on('click', () => {
        /* TRACKING */
        Tracking.dataLayerPush({
          clickCode: '',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'Multicottage-Popin accommodation',
          gaLabel: 'Contact us',
          event: 'clickEvent'
        });
      });

      $('.searchForm-quantityBlock--Cottage .form-QuantityRemover').removeClass('u-disabled');
      $('.searchForm-quantityBlock--Cottage .form-QuantityAdder').addClass('u-disabled');
      $('#js-searchEngine-cottageNumber').val(2);
      $('#js-searchEngine-adultNumber_02').val(2);

      $('.js-goToFilters, .searchbar').addClass('isMulticottage');

      if (!DEVICE.isMobile && $('#searchEngine-children_02 + .searchForm-quantityBlockLine .selectKidAgeMulticottage').length > 0) {
        $('#searchEngine-children + .searchForm-quantityBlockLine .kidsSelectorLabel').show();
      }

      dispatcher.trigger('facette:participants:updateFieldParticipants');
      if (!DEVICE.isMobile) {
        dispatcher.trigger('kidsAges:calculateHeightBlock');
      }
    }

    /* TRACKING */
    Tracking.dataLayerPush({
      clickCode: 'clickMainSearch',
      gaCategory: PAGE_SCRIPTS.page_template,
      gaAction: 'Multicottage-Popin accommodation',
      gaLabel: 'add accommodation',
      event: 'clickEvent'
    });
  },

  hidePanelParticipants: function () {
    if (!$('#mainCalendar').hasClass('isFlex')) {
      $('.js-dateFlexType.dateFlex').removeClass('disable');
    }

    $('.searchForm-quantityBlockCottage:nth-child(2) .form-QuantityContainer, .searchForm-quantityBlock--separator').addClass('hidden');
    $('.searchForm-panel').removeClass('searchForm-panel--bigger');
    $('.searchForm-quantityBlock--Cottage').removeClass('opened');
    $('.searchForm-quantityBlock--Cottage .form-QuantityRemover').addClass('u-disabled');
    $('.searchForm-quantityBlock--Cottage .form-QuantityAdder').removeClass('u-disabled');
    $('.searchForm-quantityBlock--information').addClass('hidden');
    $('body').removeClass('popinOpened');
    $('#js-searchFilters').removeClass('u-Hidden');
    $('.searchbar').removeClass('noFilter');
    $('#js-searchEngine-cottageNumber').val(1);
    $('#js-searchEngine-adultNumber_02').val(0);
    $('#js-searchEngine-seniorNumber_02').val(0);
    $('#js-searchEngine-childrenNumber_02').val(0);
    $('#js-searchEngine-petsNumber_02').val(0);
    $('.kidsAgesContainerMulticottage').html('');

    delete this.temporaryModel.get('multiparticipants')[1];

    if (DEVICE.isMobile) {
      $('#searchEngine-children_02 + .searchForm-quantityBlockLine .kidsSelectorLabel').hide();
    } else if (this.temporaryModel.get('multiparticipants')[0].ages.length < 1) {
      const $labeLSelectAge = $('#searchEngine-children + .searchForm-quantityBlockLine .kidsSelectorLabel');
      $labeLSelectAge.hide();
      $('#searchEngine-children ~ .searchForm-quantityBlockLine').each(function() {
        $(this).find('.js-customSelectOption.selected').each(function() {
          if ($(this).val() === 0) {
            $labeLSelectAge.show();
          }
        });
      });
      $('.searchForm-quantityBlockLineChildren').height('');
    }

    dispatcher.trigger('facette:participants:updateFieldParticipants');
    if (!DEVICE.isMobile) {
      dispatcher.trigger('kidsAges:calculateHeightBlock');
    }

    /* TRACKING */
    Tracking.dataLayerPush({
      clickCode: 'clickMainSearch',
      gaCategory: PAGE_SCRIPTS.page_template,
      gaAction: 'Multicottage-Popin accommodation',
      gaLabel: 'less accommodation',
      event: 'clickEvent'
    });
  },

  render: function (facette, init = false) {
    //mise à jour du nombre de participants
    oParticipantsRules.adults.max = facette.maxAdults === 0 ? 18 : facette.maxAdults;//NB : test ajouté pour corriger bug stored search params RELATED
    oParticipantsRules.seniors.max = facette.maxSeniors;
    oParticipantsRules.children.max = facette.maxChildren;
    oParticipantsRules.babies.max = facette.maxBabies;
    oParticipantsRules.pets.max = facette.maxPets;
    oParticipantsRules.values = facette.values;
    oParticipantsRules.maxParticipants = oParticipantsRules.adults.max + oParticipantsRules.babies.max;
    const maxParticipants = oParticipantsRules.adults.max + oParticipantsRules.babies.max;//ER2813 : gestion de la suppression du loader

    this.temporaryModel.set({'participantsRules': oParticipantsRules}, {silent: true});

    //disable previous quantity selector to not instanciate twice
    $('.js-searchFormList .js-quantitySelect').off('click');
    dispatcher.trigger('facette:participants:initCapacity', init);

    if (this.isFacetteMultiParticipants && this.isFirstLoad) {
      dispatcher.trigger('kidsAges:render');
      this.isFirstLoad = false;
    }

    //ER2813 : gestion de la suppression du loader
    //lorsque le max participants change suite à une modification des âges => il faut faire un rendu pour éviter les erreurs
    if (this.memoMaxParticipants - maxParticipants > 0 && this.lastParticipantsModified === 'ages') {
      this.memoMaxParticipants = maxParticipants;
      const nbParticipants = this.temporaryModel.get('multiparticipants')[0].adults + this.temporaryModel.get('multiparticipants')[0].seniors + $('.js-selectKidAge-container').length;

      if (nbParticipants > maxParticipants) {
        loader.display('.kidsAgesContainer');
        dispatcher.trigger('kidsAges:render');
        this.updateFieldParticipants();
        loader.remove('.kidsAgesContainer');
        $('#searchEngine-children .js-formQuantity-errorMessage2').removeClass('u-Hidden').addClass('display-alertError');

        //tracking de l'erreur
        const nbSelectBabies = $('.js-selectKidAge-container.isBaby').length,
          nbSelectChildren = $('.js-selectKidAge-container.isKid').length,
          nbSelectAgeEmpty = $('.js-selectKidAge-container:not(.isBaby):not(.isKid)').length,
          gaLabel = `${nbSelectBabies} babies, ${nbSelectChildren} children, ${nbSelectAgeEmpty} empty select`;

        const trackingData = {
          'event': 'participantsAgeError',
          'gaCategory': PAGE_SCRIPTS.page_template,
          'gaAction': 'select age',
          'gaLabel': gaLabel,
          'gaValue': 1
        };

        Tracking.dataLayerPush(trackingData);
      }
    } else if (this.memoMaxParticipants - maxParticipants < 0) {
      this.memoMaxParticipants = maxParticipants;
    }
  }
});